export const STORE_PANEL_STAGE_FORM_PATH = 'panels/admission/panelStageForm/';
